const utils = require('../../../lib/utils')
const getToggle = (fieldCode, langDependentNames = { 'de-at': 'Feldname'}) => ({
    fieldCode,
    config: {
        strict: true,
        slimSwitch: true
    },
    atom: {
        code: 'BOOLEAN_TOGGLE',
        dataType: 'boolean',
        renderType: 'toggle',
    },
    lang: utils.isCollection(langDependentNames) ? utils.mapValues(langDependentNames, value => utils.isCollection(value) ? value : { label: value }) : { 'de-at': { label: langDependentNames }},
})

module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form',
    ],

    formMapping: {
        cols: [[{
            type: 'fieldGroup',
            source: 'resourceFields'
        }]]
    },

    config: {
        simpleSubForm: true,
    },


    model: {
        fields: [
            {
                fieldCode: 'passwordGenerator',
                config: {
                    preventFieldLabel: true,
                },
                atom: {
                    code: 'PASSWORD_GENERATOR',
                    dataType: 'json',
                    renderType: 'passwordGenerator'
                },
                dataJSON: {},
            },
            getToggle('setAndSendViaMail', 'Per Mail Senden'),
            getToggle('setAndSendViaSMS', 'Per SMS Senden'),
            getToggle('setAndCopy', 'In die Zwischenablage kopieren'),
        ]
    },

    methods: {
        prepare(){
            const fieldConfig = this.model.config || {}
            for(const fieldCode in fieldConfig.fields || {}){
                utils.forEach(this.model.fields || [], (field, modelFieldIndex) => {
                    if(field.fieldCode === fieldCode){
                        // hide options which should not be available instead of disabling them.
                        if(field.config.disabled){
                            this.model.fields.splice(modelFieldIndex, 1)
                        } else {
                            utils.refMerge(field.config, fieldConfig.fields[fieldCode])
                        }
                        return false
                    }
                })
            }
        },

        /**
         * this function will be called after the form values has been changed.
         *
         * @param isRelationChange 		boolean - was the change related to a relation or not
         * @param changeDone 			boolean - has a change been done
         * @param fieldData 			object - fieldData used to define what to do
         */
        onChange: function(isRelationChange, changeDone, fieldData){
            // NOTE: this function can be overwritten by inherited form components if needed
            const passwordMeta = (this.model.dirtyFields.data || {}).attributes || {}

            this.closest('base_form_fields_userAndPassword', component => {
                if(passwordMeta.passwordGenerator){
                    component.updatePasswordMeta(utils.simpleCopy(passwordMeta))
                    this.showAdditionalFields()
                } else {
                    // if no password change is done the other options are useless. (e.g., sending a mail of the newly generated password makes sense only if a new password has been set.)
                    component.updatePasswordMeta(null)
                    this.hideAdditionalFields()
                }
            })

            if(fieldData.fieldCode === 'passwordGenerator'){
                this.triggerClosest('refreshDimensions', {}, 'base_popover_popover')
            }
        },

        showAdditionalFields(){
            for(const fieldCode in this.model.namedFields){
                if(fieldCode !== 'passwordGenerator'){
                    this.$.find(`.fieldOf_${fieldCode}`).addClass('active')
                }
            }
        },

        hideAdditionalFields(){
            for(const fieldCode in this.model.namedFields){
                if(fieldCode !== 'passwordGenerator'){
                    this.$.find(`.fieldOf_${fieldCode}`).removeClass('active')
                }
            }
        },
    },

    handlers: [{
        name: 'onSubmitDone',
        componentClass: 'base_form_form',
        handle: function(callerComponent, nodeData, insertPerformed){
            this.furthest('base_form_form', undefined, form => {
                if((callerComponent || {}).componentIndex && form.componentIndex && (callerComponent || {}).componentIndex === form.componentIndex){
                    // copy password to clipboard if necessary
                    const password = ((nodeData || {}).meta || {}).copyPassword
                    if(password){
                        utils.copyToClipboard(password)
                    }

                    this.closest('base_form_fields_userAndPassword', component => {
                        // reset passwordMeta after submit
                        component.updatePasswordMeta(null)
                        this.hideAdditionalFields()
                    })
                }
            })
        }
    }]
}